<template>
  <div class="page">
    <header class="page-header">
      <h1>{{ isEdit ? 'Editar encontro' : 'Novo encontro' }}</h1>
      <button class="btn-secondary" @click="$router.push('/')">← Voltar</button>
    </header>

    <form @submit.prevent="salvar" class="card form">
      <div class="form-group">
        <label class="label">Nome *</label>
        <input class="input" v-model="form.nome" required maxlength="200" />
      </div>

      <div class="form-group">
        <label class="label">Slug (URL) *</label>
        <input
          class="input"
          v-model="form.slug"
          required
          maxlength="42"
          placeholder="ex: encontro-jovens"
          @input="form.slug = form.slug.toLowerCase().replace(/[^a-z0-9-]/g, '')"
        />
        <span class="help">
          A URL ficará em <code>https://{{ form.slug || '...' }}.checkin.naelshaday.com.br</code>.
          Use apenas letras minúsculas, números e hífen.
        </span>
        <span v-if="isEdit && form.slug !== originalSlug" class="aviso">
          ⚠ Mudar o slug invalida URLs antigas (<code>{{ originalSlug }}.checkin...</code> deixa de funcionar). Sessões ativas no subdomínio anterior precisarão logar de novo.
        </span>
      </div>

      <div class="form-group">
        <label class="label">Descrição</label>
        <textarea class="textarea" v-model="form.descricao" rows="3" maxlength="1000"></textarea>
      </div>

      <div class="form-group">
        <label class="label">Cor (badge)</label>
        <input class="input cor-input" type="color" v-model="form.cor" />
      </div>

      <div class="form-group">
        <label class="check-row">
          <input type="checkbox" v-model="form.ativo" />
          <span>Ativo (inativo bloqueia acesso ao subdomínio)</span>
        </label>
      </div>

      <p v-if="erro" class="erro">{{ erro }}</p>

      <div class="actions">
        <button type="submit" class="btn-primary" :disabled="saving">
          {{ saving ? 'Salvando…' : (isEdit ? 'Salvar alterações' : 'Criar encontro') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import api from '../lib/api'

export default {
  name: 'EncontroFormPage',
  data() {
    return {
      form: { nome: '', slug: '', descricao: '', cor: '#1d4ed8', ativo: true },
      originalSlug: '',
      saving: false,
      erro: ''
    }
  },
  computed: {
    isEdit() { return !!this.$route.params.id }
  },
  async mounted() {
    if (this.isEdit) {
      try {
        const { data } = await api.get('/encontros')
        const found = (data.encontros || []).find(e => e.id === this.$route.params.id)
        if (found) {
          this.form = {
            nome: found.nome,
            slug: found.slug,
            descricao: found.descricao || '',
            cor: found.cor || '#1d4ed8',
            ativo: found.ativo
          }
          this.originalSlug = found.slug
        }
      } catch (err) {
        this.erro = 'Falha ao carregar encontro'
      }
    }
  },
  methods: {
    async salvar() {
      this.erro = ''
      this.saving = true
      try {
        const payload = {
          nome: this.form.nome,
          descricao: this.form.descricao || null,
          cor: this.form.cor || null,
          ativo: this.form.ativo
        }
        payload.slug = this.form.slug
        if (!this.isEdit) {
          await api.post('/encontros', payload)
          this.$toast.open({ message: 'Encontro criado!', type: 'success', position: 'top-right' })
        } else {
          await api.patch(`/encontros/${this.$route.params.id}`, payload)
          this.$toast.open({ message: 'Encontro atualizado', type: 'success', position: 'top-right' })
        }
        this.$router.push('/')
      } catch (err) {
        const detail = err.response?.data
        if (Array.isArray(detail?.errors)) {
          this.erro = detail.errors.map(e => `${e.field}: ${e.message}`).join(' · ')
        } else {
          this.erro = detail?.message || 'Falha ao salvar'
        }
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.page { max-width: 640px; margin: 0 auto; padding: var(--spacing-base); display: flex; flex-direction: column; gap: var(--spacing-base); }
.page-header { display: flex; justify-content: space-between; align-items: center; gap: var(--spacing-base); }
.page-header h1 { margin: 0; }
.card { background: white; border-radius: var(--radius-md); border: 1px solid var(--color-border); padding: var(--spacing-base); }
.form { display: flex; flex-direction: column; gap: var(--spacing-base); }
.form-group { display: flex; flex-direction: column; gap: 4px; }
.label { font-weight: 500; font-size: var(--text-sm); }
.input, .textarea { padding: 10px 12px; border: 1px solid var(--color-border); border-radius: var(--radius-md); font-size: var(--text-base); font-family: inherit; }
.textarea { resize: vertical; }
.cor-input { padding: 4px; height: 42px; width: 100%; cursor: pointer; }
.help { color: var(--color-text-muted); font-size: 12px; }
code { background: #f1f5f9; padding: 1px 4px; border-radius: 3px; font-size: 0.9em; }
.check-row { display: flex; align-items: center; gap: 8px; cursor: pointer; }
.erro { background: #fee2e2; color: #b91c1c; padding: 8px 12px; border-radius: var(--radius-md); font-size: var(--text-sm); }
.aviso { background: #fef3c7; color: #92400e; padding: 8px 12px; border-radius: var(--radius-md); font-size: 12px; margin-top: 4px; }
.actions { display: flex; gap: 8px; }
.btn-primary, .btn-secondary { padding: 10px 16px; border-radius: var(--radius-md); font-weight: 500; cursor: pointer; border: 0; }
.btn-primary { background: #2563eb; color: white; }
.btn-secondary { background: #e2e8f0; color: #0f172a; }
.btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }
</style>
